import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const ResetPasswordScreen = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      return setMessage("Remplissez tous les champs");
    }

    if (password !== confirmPassword) {
      return setMessage("Les mots de passe ne correspondent pas");
    }

    try {
      setLoading(true);
      setMessage("");

      const response = await fetch(
        "https://api.joss-serveur.duckdns.org/auth/reset-password",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token,
            password,
          }),
        }
      );

      const data = await response.json();

      if (data.success) {
        setMessage("Mot de passe réinitialisé avec succès");

        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        setMessage(data.message || "Erreur");
      }
    } catch (err) {
      console.error(err);
      setMessage("Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#111",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 400,
          background: "#1a1a1a",
          padding: 30,
          borderRadius: 16,
          boxShadow: "0 0 20px rgba(0,0,0,0.4)",
        }}
      >
        <h1
          style={{
            color: "#c8a95b",
            textAlign: "center",
            marginBottom: 30,
          }}
        >
          Nouveau mot de passe
        </h1>

        <form onSubmit={handleResetPassword}>
          <input
            type="password"
            placeholder="Nouveau mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{
              width: "100%",
              padding: 14,
              marginBottom: 15,
              borderRadius: 10,
              border: "none",
              background: "#222",
              color: "#fff",
              fontSize: 16,
            }}
          />

          <input
            type="password"
            placeholder="Confirmer le mot de passe"
            value={confirmPassword}
            onChange={(e) =>
              setConfirmPassword(e.target.value)
            }
            style={{
              width: "100%",
              padding: 14,
              marginBottom: 20,
              borderRadius: 10,
              border: "none",
              background: "#222",
              color: "#fff",
              fontSize: 16,
            }}
          />

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: 14,
              borderRadius: 10,
              border: "none",
              background: "#c8a95b",
              color: "#000",
              fontWeight: "bold",
              fontSize: 16,
              cursor: "pointer",
            }}
          >
            {loading
              ? "Chargement..."
              : "Réinitialiser"}
          </button>
        </form>

        {message && (
          <p
            style={{
              color: "#fff",
              marginTop: 20,
              textAlign: "center",
            }}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordScreen;